import { TileSize } from "common/consts/googleMaps";
import {
  blueShinsuiColors,
  originalShinsuiColors
} from "common/consts/shinsuiColors";

export class HazardMapType {
  id = "";
  infowindow = new google.maps.InfoWindow();
  map: google.maps.Map | null = null;
  baseUrls: string[] = [];
  maxZoom: number;
  tileSize = new google.maps.Size(TileSize, TileSize);
  opacity = 0.3;
  isBlue = false;

  constructor(
    id: string,
    map: google.maps.Map,
    baseUrls: string[],
    maxZoom: number,
    opacity: number = 0.3,
    isBlue: boolean = false
  ) {
    this.id = id;
    this.map = map;
    this.baseUrls = baseUrls;
    this.maxZoom = maxZoom;
    this.opacity = opacity;
    this.isBlue = isBlue;
  }

  getTile = (coord: google.maps.Point, zoom: number, ownerDocument: any) => {
    const div = ownerDocument.createElement("div") as HTMLElement;

    const calcTileInfo = {
      zoom: zoom,
      x: coord.x,
      y: coord.y,
      width: this.tileSize.width,
      height: this.tileSize.height,
      positionX: 0,
      positionY: 0
    };

    if (zoom > this.maxZoom) {
      const zoomGap = zoom - this.maxZoom;
      const multiply = Math.pow(2, zoomGap);

      calcTileInfo.zoom = this.maxZoom;
      calcTileInfo.x = Math.trunc(coord.x / multiply);
      calcTileInfo.y = Math.trunc(coord.y / multiply);
      calcTileInfo.width = this.tileSize.width * multiply;
      calcTileInfo.height = this.tileSize.height * multiply;
      calcTileInfo.positionX = this.tileSize.width * (coord.x % multiply) * -1;
      calcTileInfo.positionY = this.tileSize.height * (coord.y % multiply) * -1;
    }

    // div.innerHTML = `${calcTileInfo.x}, ${calcTileInfo.y}`;
    div.style.width = `${this.tileSize.width}px`;
    div.style.height = `${this.tileSize.height}px`;

    for (const baseUrl of this.baseUrls) {
      const replacedBaseUrl = baseUrl
        .replace("{z}", `${calcTileInfo.zoom}`)
        .replace("{x}", `${calcTileInfo.x}`)
        .replace("{y}", `${calcTileInfo.y}`);

      const imgDiv = document.createElement("div");

      imgDiv.style.position = "absolute";
      imgDiv.style.width = `${this.tileSize.width}px`;
      imgDiv.style.height = `${this.tileSize.height}px`;
      if (!this.isBlue) {
        imgDiv.style.backgroundImage = `url(${replacedBaseUrl})`;
      }
      imgDiv.style.backgroundSize = `${calcTileInfo.width}px ${calcTileInfo.height}px`;
      imgDiv.style.backgroundPositionX = `${calcTileInfo.positionX}px`;
      imgDiv.style.backgroundPositionY = `${calcTileInfo.positionY}px`;
      imgDiv.style.opacity = this.opacity.toString();

      div.appendChild(imgDiv);

      if (this.isBlue) {
        const img = new Image();
        img.crossOrigin = "anonymous";

        img.onload = () => {
          const canvas = document.createElement("canvas");

          canvas.width = img.width;
          canvas.height = img.height;

          const ctx = canvas.getContext("2d", { willReadFrequently: true });

          if (!ctx) return;

          ctx.drawImage(img, 0, 0);
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const data = imageData.data;

          for (let i = 0; i < data.length; i += 4) {
            const a = data[i + 3];
            if (a === 0) continue;

            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];

            if (
              Math.abs(r - g) < 15 &&
              Math.abs(g - b) < 15 &&
              Math.abs(r - b) < 15
            )
              continue;

            let minDist = Infinity;
            let closestIndex = -1;

            for (let j = 0; j < originalShinsuiColors.length; j++) {
              const dr = r - originalShinsuiColors[j].r;
              const dg = g - originalShinsuiColors[j].g;
              const db = b - originalShinsuiColors[j].b;
              const dist2 = dr * dr + dg * dg + db * db;

              if (dist2 < minDist) {
                minDist = dist2;
                closestIndex = j;
              }
            }

            if (minDist < 10000 && closestIndex !== -1) {
              data[i] = blueShinsuiColors[closestIndex].r;
              data[i + 1] = blueShinsuiColors[closestIndex].g;
              data[i + 2] = blueShinsuiColors[closestIndex].b;
            }
          }

          ctx.putImageData(imageData, 0, 0);

          imgDiv.style.backgroundImage = `url(${canvas.toDataURL("image/png")})`;
        };

        img.onerror = () => {};

        img.src = replacedBaseUrl;
      }
    }

    return div;
  };

  releaseTile = (tile: any) => {
    if (tile.parentElement) {
      tile.parentElement.removeChild(tile);
    }
  };
}
